<template>
  <div class="BottleSelection" :class="{ 'BottleSelection--endPage': showBar}" :style="{ 'background-image': `url(${backgroundImage})` }">
    <transition name="u-slide-down">
      <div v-if="showBar" class="BottleSelection__bar">
        <a class="BottleSelection__link" href="https://www.theglenlivet.com/en-EN/our-community/join-us" target="_blank">Join the guardians</a>
      </div>
    </transition>
    <Page>
      <div class="BottleSelection__content">
        <transition name="u-zoom-in">
          <div v-if="show.logos.one" class="BottleSelection__logo BottleSelection__contentOne">
            <a
              class="BottleSelection__link"
              @click.prevent="gotToBottle('orchard')"
            >
              <img alt="Bottle Selection Logo One" src="../assets/bottle-selection-one.png">
              <div v-if="lsState && !startScreen">
                <p v-if="lsState.orchard" class="BottleSelection__meta">explored</p>
                <p v-else class="BottleSelection__meta">undiscovered</p>
              </div>
            </a>
          </div>
        </transition>
        <transition name="u-zoom-in">
          <div v-if="show.logos.two" class="BottleSelection__logo BottleSelection__contentTwo">
            <a
              class="BottleSelection__link"
              @click.prevent="gotToBottle('smoke')"
            >
              <img alt="Bottle Selection Logo Two" src="../assets/bottle-selection-two.png">
              <div v-if="lsState && !startScreen">
                <p v-if="lsState.smoke" class="BottleSelection__meta">explored</p>
                <p v-else class="BottleSelection__meta">undiscovered</p>
              </div>
            </a>
          </div>
        </transition>
        <transition name="u-zoom-in">
          <div v-if="show.logos.three" class="BottleSelection__logo BottleSelection__contentThree">
            <a
              class="BottleSelection__link"
              @click.prevent="gotToBottle('chard')"
            >
              <img alt="Bottle Selection Logo Three" src="../assets/bottle-selection-three.png">
              <div v-if="lsState && !startScreen">
                <p v-if="lsState.chard" class="BottleSelection__meta">explored</p>
                <p v-else class="BottleSelection__meta">undiscovered</p>
              </div>
            </a>
          </div>
        </transition>
      </div>
    </Page>
  </div>
</template>

<script>

  import { audioMixin } from '../mixins/audioMixin';

  const DEFAULT_BACKGROUND_IMAGE = require('../assets/bottle-selection-bg.jpg');

  import Page from "../components/Page";
  export default {
    components: {Page},
    mixins: [audioMixin],
    data() {
      return {
        lsState: {},
        showBar: false,
        scrollY: null,
        show: {
          logos: {
            one: false,
            two: false,
            three: false
          },
          backgrounds: {
            one: false,
            two: false,
            three: false
          }
        }
      }
    },
    computed: {
      startScreen() {
        return !this.lsState.orchard && !this.lsState.smoke && !this.lsState.chard
      },
      backgroundImage() {
        return DEFAULT_BACKGROUND_IMAGE
      },
    },
    mounted() {
      this.lsState = JSON.parse(sessionStorage.getItem('glenlivet_state'))
      setTimeout(() => {
        this.show.logos.one = true
      }, 250)
      setTimeout(() => {
        this.show.logos.two = true
      }, 500)
      setTimeout(() => {
        this.show.logos.three = true
      }, 750)

      // if coming from end page
      if (this.$route.query.end === 'true') {
        setTimeout(() => {
          this.showBar = true
        }, 500)
      }

      this.scrollY = window.scrollY
    },
    methods: {
      gotToBottle(theme) {
        this.playSound(`video-${theme}`)
        this.$router.push({
          path: '/video',
          query: {
            theme: theme
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/variables.scss';
  @import '../scss/mixins.scss';

  .BottleSelection {
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100%;
    margin: 0 auto;
    overflow: hidden;

    &__background {
      position: absolute;
      max-width: 100%;
      &--one {
        top: 0;
        left: 0;
        display: block;
        z-index: 2;
      }
      &--two {
        top: 0;
        right: 0;
        z-index: 0;
      }
      &--three {
        bottom: 0;
        left: 0;
        z-index: 1;
      }
    }
    /*
    &--endPage {
      position: relative;
      &:before {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
      }
    } */
    &__link {
      text-decoration: none;
    }
    &__meta {
      color: $white;
      display: block;
      position: relative;
      text-align: center;
      text-decoration: none !important;
      &:before {
        background-color: $white;
        content: '';
        position: absolute;
        left: auto;
        margin-left: -15px;
        top: 8px;
        width: 8px;
        height: 1px;
        z-index: 9999;
      }
      &:after {
        background-color: $white;
        content: '';
        position: absolute;
        right: auto;
        margin-left: 7.5px;
        top: 8px;
        width: 8px;
        height: 1px;
        z-index: 9999;
      }
    }
    &__content {
      height: 100%;
      position: relative;
      z-index: 3;
      // iPhone 5
      @media (device-height : 568px)
      and (device-width : 320px) {
      height: 85%;
      }
    }
    &__contentOne {
      position: absolute;
      top: 14%;
      left: 8%;
    }
    &__contentTwo{
      position: absolute;
      top: 34%;
      left: 57%;
    }
    &__contentThree{
      position: absolute;
      top: 60%;
      left: 8%;
    }
    &__logo {
      transform: translatey(0px);
      animation: float 20s ease-in-out infinite;
      img {
        max-width: 110px;
        // 750 is max width of assets in Sketch
        @include rwd(750) {
          max-width: 110px * 2;
        }
      }
      &:nth-child(2) {
        animation-direction: alternate;
        animation-duration: 24s;
      }
      &:nth-child(3) {
        animation-duration: 16s;
      }

    }
    &__bar {
      display: flex;
      background: #000;
      border-radius: 0 0 10px 10px;
      height: 70px;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 100%;
      left: 0;
      z-index: 4;
      a {
        display: inline-block;
        font-family: $secondary-font;
        text-transform: uppercase;
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 1.29px;
        position: relative;
        &:after {
          background-image: $chard-gradient;
          content: ' ';
          position: absolute;
          bottom: -5px;
          height: 2px;
          width: 100%;
          left: 0;
        }
      }
    }

    @keyframes float {
      0% {
        transform: translate(0%,0%);
      }
      25% {
        transform: translate(5%,15%);
      }
      50% {
        transform: translate(10%,5%);
      }
      75% {
        transform: translate(0%,15%);
      }
      100% {
        transform: translate(0%,0%);
      }
    }
  }
</style>
